export const getGapChannelGapCellValue = (
    gapChannel: TrqkGapChannel,
): number => {
    const { detections_raw, performances_matched_total } = gapChannel;

    return detections_raw - (performances_matched_total ?? 0);
};
